import { translateText } from "infra/translation/translate";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { useEffect } from "react";

const confirmAction = (message: string, acceptCallback: () => void) => {
    confirmDialog({
      message: message,
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: acceptCallback,
    });
  };


interface ParamProps {
  toast: React.RefObject<Toast | null>;
  populateDistanceMutation: () => void;
  populateDistanceError: any;
  isPopulateDistanceError: boolean;
  isPopulateDistanceSuccess: boolean;
  distancePopulated: any;
  isPopulatePending: boolean;
}

const HeaderDistanceGrid: React.FC<ParamProps> = ({ 
  toast,
  populateDistanceMutation,
  populateDistanceError,
  isPopulateDistanceError,
  isPopulateDistanceSuccess,
  distancePopulated,
  isPopulatePending
}) => {

  const handlePopulate = async () => {
    populateDistanceMutation();
  };

  useEffect(() => {
    if (isPopulateDistanceSuccess) {
      const successMessage = "Distâncias dos trabalhadores remotos populadas com sucesso";
      toast.current?.show({
        severity: "success",
        summary: "Sucesso",
        detail: successMessage,
        life: 2000,
      });
    }
  }, [isPopulateDistanceSuccess]);

  useEffect(() => {
    if (isPopulateDistanceError) {
      let message = [];
      message.push(populateDistanceError.message);
      message = populateDistanceError.response.data.metadata.errors;
      console.log("message", message);
      message.map((item: string) => {
        toast.current?.show({
          severity: "error",
          summary: "Erro",
          detail: item || "Ocorreu um erro inesperado",
          life: 2000,
        });
      });
    }
  }, [populateDistanceError, isPopulateDistanceError]);


  return (
    <div className="flex justify-content-end">
      
      <div style={{ display: "flex", gap: "10px" }}>
        <Button
          type="button"
          icon="pi pi-refresh"
          label={translateText("Atualizar", "pt")}
          outlined
          onClick={() =>
            confirmAction("Deseja atualizar a tabela das distâncias, criando as distâncias dos trabalhadores remotos em falta?", 
            handlePopulate)
          }
          style={{
            backgroundColor: "#2196F3",
            borderColor: "#2196F3",
            color: "white",
            borderRadius: "8px",
          }}
        />
      </div>
    </div>
  );
};
export default HeaderDistanceGrid;
